//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['widget'],
    computed: {
        colors() {
            switch (this.widget.fields.background) {
                case 'Accent':
                    return 'bg-[#ECF6DD] text-black';
                case 'White':
                    return 'bg-white text-black';
                default:
                    return 'bg-white text-black';
            }
        },
        center() {
            return this.widget.fields.items.length > 1 ? 'text-left' : 'text-center';
        },
        cols() {
            switch (this.widget.fields.items.length) {
                case 1:
                    return 'lg:grid-cols-1';
                case 2:
                    return 'lg:grid-cols-2';
                case 3:
                    return 'lg:grid-cols-3';
                default:
                    return 'lg:grid-cols-1';
            }
        },
    },
};
